import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Input, Popconfirm, Popover, Space, Table, Divider, Dropdown, Modal, Checkbox, Alert, Menu } from 'antd'
import { DeleteOutlined, EyeOutlined, SearchOutlined, ProfileOutlined } from '@ant-design/icons'
import * as Constants from '../../../constants'
import './styles.css'
import { useHistory } from 'react-router-dom'
import { storage } from '../../../config/Fire'
import moment from 'moment'

const { TextArea } = Input


const BidOrdersTable = ({ data, employees, clients, outsourcing, onRemoveBidOrder, onShowBidOrder, loading, onGenerateWorkOrder, works }) => {
    const [searchedColumn, setSearchedColumn] = useState('')
    const [searchText, setSearchText] = useState('')
    let searchInput = useRef(null)
    const history = useHistory()
    const linkFileRef = useRef(null)
    const [filteredData, setFilteredData] = useState([]);
    const [isSelectItemsModalVisible, setIsSelectItemsModalVisible] = useState(false)
    const [selectedBidForHire, setSelectedBidForHire] = useState(null)
    const [selectedItemsKeys, setSelectedItemsKeys] = useState([])
    const [usedItemsKeys, setUsedItemsKeys] = useState([]) // Items ya usados en works existentes
    const [quotationObservations, setQuotationObservations] = useState('')

    useEffect(() => {
        if (!data || !outsourcing) return;
        const outsourcingMap = new Map(Object.entries(outsourcing).map(([key, value]) => [key, value.name]));
        const updatedData = data.map(bid => {
            if (bid?.outsourcing?.length > 0) {
                bid.outsourcingNames = bid.outsourcing.map(outsourced => outsourcingMap.get(outsourced) || '');
            } else {
                bid.outsourcingNames = [];
            }
            return bid;
        });
        const sortedData = updatedData.sort((a, b) => {
            const dateComparison = parseDate(b.startDate) - parseDate(a.startDate);
            if (dateComparison !== 0) {
                return dateComparison;
            }
            const lastTwoDigitsA = a.quotation.slice(-2);
            const lastTwoDigitsB = b.quotation.slice(-2);
            return lastTwoDigitsB.localeCompare(lastTwoDigitsA);
        });
        setFilteredData(sortedData);
    }, [data, outsourcing]);

    const goToEditOT = (id) => {
        history.push(`/editar_trabajo/${id}`)
    };

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        setSearchText(selectedKeys[0])
        setSearchedColumn(dataIndex)
    }

    const handleReset = clearFilters => {
        clearFilters()
        setSearchText('')
    }

    const getKeyArea = areas => {
        const keyAreas = []
        Object.keys(Constants.areaWorkOrderMap).forEach(key => {
            areas.forEach(area => {
                if (area === Constants.areaWorkOrderMap[key]) {
                    keyAreas.push(key)
                }
            })
        })
        if (keyAreas.length === 0) {
            return `--`
        } else {
            return <Popover content={<ul>
                {
                    keyAreas.map(keyArea => <li key={keyArea}>{keyArea}: {Constants.areaWorkOrderMap[keyArea]}</li>)
                }
            </ul>}>
                <span>{keyAreas[0]} <ProfileOutlined /></span>
            </Popover>
        }
    }

    const isValueInWorkOrder = (record, value) => {
        if(record.SAT) {
            const workOrderTextFormat = `O/T SAT/${record['year'].toString().substring(2, 4)}`
            return (record['year'].toString().toLowerCase().includes(value.toLowerCase()) || workOrderTextFormat.toString().toLowerCase().includes(value.toLowerCase()))
        } else {
            const workOrderTextFormat = `O/T Nº${record['workOrderNumber']}/${record['year'].toString().substring(2, 4)}`
            return (record['workOrderNumber'].toString().toLowerCase().includes(value.toLowerCase()) || record['year'].toString().toLowerCase().includes(value.toLowerCase()) || workOrderTextFormat.toString().toLowerCase().includes(value.toLowerCase()))
        }
    }

    const isAreasMatched = (areas, value) => {
        let isValue = false
        Object.keys(Constants.areaWorkOrderMap).forEach(initials => {
            areas.forEach(area => {
                if ((Constants.areaWorkOrderMap[initials] === area && initials.toString().toLowerCase().includes(value.toString().toLowerCase()))
                    || area.toString().toLowerCase().includes(value.toLowerCase())) {
                    isValue = true
                }
            })
        })
        return isValue
    }

    const getColumnSearchProps = (dataIndex, name) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput = node
                    }}
                    placeholder={`Buscar ${name}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined/>}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Limpiar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#279FA3' : undefined }}/>,
        onFilter: (value, record) =>
            record[dataIndex] !== undefined
            ? dataIndex === 'workOrderNumber'
                ? isValueInWorkOrder(record, value)
                : dataIndex === 'areas'
                    ? isAreasMatched(record[dataIndex], value)
                    : dataIndex === 'hasTopography'
                        ? (record[dataIndex] === true ? 'Pendiente de viaje' : record[dataIndex] === false ? 'No contempla' : record[dataIndex])
                            .toString().toLowerCase().includes(value.toLowerCase())
                        : record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100)
            }
        },
        render: (text, record) =>
            'completionPercentage' === dataIndex ?
                text === 100 ?
                    <span className="workOrderCompletedPercentage">{`${text} %`}</span>
                    :
                    <span>{`${text} %`}</span>
                :
                'workOrderNumber' === dataIndex ?
                    record.SAT ?
                        <span>O/T SAT/{record['year'].toString().substring(2, 4)}</span>
                        :
                        <span>O/T Nº{record['workOrderNumber']}/{record['year'].toString().substring(2, 4)}</span>
                    :
                    'areas' === dataIndex ?
                        <span>{getKeyArea(text)}</span>
                        :
                        <span>{text}</span>
    })

    const downloadFile = (prop) => {
        storage.ref().child(prop.fileUrl).getDownloadURL().then(url => {
            if(linkFileRef && linkFileRef.current) {
                linkFileRef.current.href = url
                linkFileRef.current.click();
                linkFileRef.current.remove();
            }
        })
    }

    const parseDate = (dateString) => {
        // Verificar si la fecha es un objeto moment
        if (moment.isMoment(dateString)) {
            return dateString.format('DD/MM/YYYY');
        }

        // Verificar si la fecha es un objeto Date
        if (dateString instanceof Date) {
            return moment(dateString).format('DD/MM/YYYY');
        }
        const parts = dateString?.split('/');
        if (parts.length === 3) {
            // Formato es DD/MM/YYYY
            return new Date(parts[2], parts[1] - 1, parts[0]);
        }
        return new Date(NaN);
    };

    // Helper para obtener works relacionados a un bid (compatibilidad con registros viejos)
    const getWorksForBid = (bidId) => {
        if (!works || !bidId) return []
        // Buscar works por bidId (nueva forma)
        const worksByBidId = Object.values(works).filter(work => work.bidId === bidId)
        return worksByBidId.sort((a, b) => {
            // Ordenar por versión (si no tiene versión, asumimos 1)
            const versionA = a.version || 1
            const versionB = b.version || 1
            return versionA - versionB
        })
    }

    // Helper para verificar si un bid tiene works (compatibilidad con registros viejos)
    const hasWorks = (record) => {
        // Primero verificar si tiene workOrderId (registros viejos)
        if (record.workOrderId) {
            return true
        }
        // Luego verificar si tiene works por bidId
        const worksForBid = getWorksForBid(record.id)
        return worksForBid.length > 0
    }

    // Helper para obtener el label de una OT
    const getOTLabel = (work) => {
        const company = work?.company === 'SD' ? 'SYD' : work?.company === 'Arcasa' ? 'ARC' : 'O/T'
        const version = work.version ? ` v${work.version}` : ''
        if (work.SAT) {
            return `${company} Nº${work['workOrderNumber']}/${work['year']?.toString().substring(2, 4)} (SAT)${version}`
        } else {
            return `${company} Nº${work['workOrderNumber']}/${work['year']?.toString().substring(2, 4)}${version}`
        }
    }

    // Obtener items ya usados en works existentes para un bid
    const getUsedItemsForBid = (bidId) => {
        if (!works || !bidId) return []
        
        const worksForBid = getWorksForBid(bidId)
        const usedItems = new Set()
        
        // Recorrer todos los works asociados al bid
        worksForBid.forEach(work => {
            // Verificar si el work tiene items guardados (puede ser 'items' o 'selectedItems')
            if (work.items && Array.isArray(work.items)) {
                work.items.forEach(item => {
                    // Si el item tiene un id, agregarlo al set
                    if (item.id !== undefined && item.id !== null) {
                        usedItems.add(item.id)
                    }
                })
            }
            // También verificar selectedItems por si acaso
            if (work.selectedItems && Array.isArray(work.selectedItems)) {
                work.selectedItems.forEach(item => {
                    if (item.id !== undefined && item.id !== null) {
                        usedItems.add(item.id)
                    }
                })
            }
        })
        
        return Array.from(usedItems)
    }

    // Abrir modal para seleccionar items
    const openSelectItemsModal = (bid) => {
        setSelectedBidForHire(bid)
        // Obtener items ya usados en works existentes
        const usedItems = getUsedItemsForBid(bid.id)
        setUsedItemsKeys(usedItems)
        // Todos los checkboxes deshabilitados (no seleccionados) de inicio, excepto los ya usados
        setSelectedItemsKeys([])
        setIsSelectItemsModalVisible(true)
    }

    // Cerrar modal
    const closeSelectItemsModal = () => {
        setIsSelectItemsModalVisible(false)
        setSelectedBidForHire(null)
        setSelectedItemsKeys([])
        setUsedItemsKeys([])
        setQuotationObservations('')
    }

    // Manejar la contratación con items seleccionados
    const handleHireWithItems = () => {
        if (!selectedBidForHire) return

        // Obtener los items seleccionados
        const selectedItems = (selectedBidForHire.items || []).filter(item => 
            selectedItemsKeys.includes(item.id)
        )

        // Cerrar modal
        closeSelectItemsModal()
        
        // Llamar a onGenerateWorkOrder con el bid, los items seleccionados y las observaciones
        if (onGenerateWorkOrder) {
            onGenerateWorkOrder(selectedBidForHire, selectedItems, quotationObservations)
        }
    }

    const columns = [
        {
            title: 'Fecha',
            dataIndex: 'startDate',
            key: 'startDate',
            align: 'center',
            sorter: (a, b) => parseDate(b.startDate) - parseDate(a.startDate),
        },
        {
            title: 'Rubro',
            dataIndex: 'category',
            key: 'category',
            align: 'center',
            ...getColumnSearchProps('category', 'category')
        },
        {
            title: 'Cotización',
            dataIndex: 'quotation',
            key: 'quotation',
            align: 'center',
            render: (text, record) => 
            <span>
                <div className='fileName' onClick={() => {downloadFile(record)}}>{text}</div>
                <a ref={linkFileRef} href="" target='_blank' download/>
            </span>
        },
        {
            title: 'Provincia',
            dataIndex: 'province',
            key: 'province',
            align: 'center',
            ...getColumnSearchProps('province', 'province')
        },
        {
            title: 'Localidad',
            dataIndex: 'city',
            key: 'city',
            align: 'center',
            ...getColumnSearchProps('city', 'city')
        },
        {
            title: 'Comitente/s',
            dataIndex: 'clientNames',
            key: 'clientNames',
            align: 'center',
            width: '6%',
        },
        {
            title: 'Proyecto',
            dataIndex: 'proyect',
            key: 'proyect',
            align: 'center',
            width: '6%',
            ...getColumnSearchProps('proyect', 'proyect')
        },
        {
            title: 'Contratada',
            dataIndex: 'workOrderId',
            key: 'workOrderId',
            align: 'center',
            width: '2%',
            render: (text, record) => {
                // Compatibilidad con registros viejos: verificar workOrderId o works por bidId
                const hasWorksBid = hasWorks(record)
                return <span>{hasWorksBid ? 'SI' : 'NO'}</span>
            }
        },
        {
            title: 'Monto total',
            dataIndex: 'amountPesos',
            key: 'amountPesos',
            align: 'center',
            width: '5%',
            sorter: (a, b) => a.amountPesos - b.amountPesos,
        },
        {
            title: 'Monto dolares',
            dataIndex: 'amountDollars',
            key: 'amountDollars',
            align: 'center',
            width: '10%',
            sorter: (a, b) => a.amountDollars - b.amountDollars,
            render: (text, record) => <span>{text ? text : '--'}</span>
        },
        {
            title: 'Forma de pago',
            dataIndex: 'paymentForm',
            key: 'paymentForm',
            align: 'center',
            width: '10%',
            render: (text, record) => <span>{text ? text : '--'}</span>
        },
        {
            title: 'Plazo en días',
            dataIndex: 'paymentTerm',
            key: 'paymentTerm',
            align: 'center',
            width: '10%',
        },
        {
            title: 'Topografía',
            dataIndex: 'hasTopography',
            key: 'hasTopography',
            align: 'center',
            ...getColumnSearchProps('hasTopography', 'topografía'),
            render: (text, record) => <span>{text === true ? 'Pendiente de viaje' : text === false ? 'No contempla' : text}</span>
        },
        {
            title: 'Proveedores',
            dataIndex: 'outsourcingNames',
            key: 'outsourcingNames',
            align: 'center',
            render: (text, record) => <span>{text ? `${text}` : '--'}</span>
        },
        {
            title: 'Kilometros previstos',
            dataIndex: 'predictedKilometers',
            key: 'predictedKilometers',
            align: 'center',
            render: (text, record) => <span>{text ? `${text}` : '--'}</span>
        },
        {
            title: 'OT',
            dataIndex: 'actions2',
            key: 'actions2',
            align: 'center',
            render: (text, record) => {
                const worksForBid = getWorksForBid(record.id)
                const hasWorksBid = hasWorks(record)
                
                // Si no tiene works, mostrar botón Contratar que abre modal de selección de items
                if (!hasWorksBid) {
                    return (
                        <Button 
                            loading={loading} 
                            onClick={(e) => {
                                e.stopPropagation()
                                openSelectItemsModal(record)
                            }}
                            disabled={loading}
                        >
                            {!loading && "Contratar"}
                        </Button>
                    )
                }
                
                // Si tiene un solo work (compatibilidad con registros viejos)
                if (worksForBid.length === 0 && record.workOrderId) {
                    return (
                        <Button loading={loading} onClick={() => {goToEditOT(record.workOrderId)}}>
                            {!loading && "Ver"}
                        </Button>
                    )
                }
                
                // Si tiene un solo work, mostrar botones directos: Ver + Contratar nueva OT
                if (worksForBid.length === 1) {
                    return (
                        <Space>
                            <Button
                                loading={loading}
                                onClick={() => { goToEditOT(worksForBid[0].id) }}
                            >
                                {!loading && 'Ver'}
                            </Button>
                            <Button
                                loading={loading}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    openSelectItemsModal(record)
                                }}
                            >
                                {!loading && 'Contratar nueva OT'}
                            </Button>
                        </Space>
                    )
                }
                
                // Si tiene múltiples works, mostrar dropdown
                const menuItems = worksForBid.map(work => (
                    <Menu.Item key={work.id} onClick={() => goToEditOT(work.id)}>
                        {getOTLabel(work)}
                    </Menu.Item>
                ))
                
                const menu = <Menu>{menuItems}</Menu>
                
                // Verificar si hay items disponibles para contratar
                const usedItems = getUsedItemsForBid(record.id)
                const bidItems = record.items || []
                const hasAvailableItems = bidItems.length === 0 || bidItems.some(item => !usedItems.includes(item.id))
                
                // Si hay items disponibles o no hay items, mostrar botón de contratar junto al dropdown
                if (hasAvailableItems) {
                    return (
                        <Space>
                            <Dropdown 
                                overlay={menu}
                                trigger={['click']}
                            >
                                <Button loading={loading} onClick={(e) => e.preventDefault()}>
                                    Ver OTs ({worksForBid.length})
                                </Button>
                            </Dropdown>
                            <Button
                                loading={loading}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    openSelectItemsModal(record)
                                }}
                            >
                                {!loading && 'Contratar nueva OT'}
                            </Button>
                        </Space>
                    )
                }
                
                // Si no hay items disponibles, solo mostrar el dropdown
                return (
                    <Dropdown 
                        overlay={menu}
                        trigger={['click']}
                    >
                        <Button loading={loading} onClick={(e) => e.preventDefault()}>
                            Ver OTs ({worksForBid.length})
                        </Button>
                    </Dropdown>
                )
            }
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            align: 'center',
            render: (text, record) =>
                <span className='actionButtons'>
                    <Button loading={loading} onClick={() => onShowBidOrder(record.id)}>{!loading && <EyeOutlined style={{ color: 'blue' }}/>}</Button>
                    <Divider type="vertical"/>
                    <Popconfirm disabled={loading} title="Se borrará la cotización, ¿Continuar?"
                                onConfirm={() => onRemoveBidOrder(record)}>
                        <Button loading={loading}>{!loading && <DeleteOutlined style={{ color: 'red' }}/>}</Button>
                    </Popconfirm>
                </span>
        }
    ]

    return (
        <>
            <Table className="bidsOrdersTableCont" dataSource={filteredData} columns={columns} rowKey="numeration" size="small" bordered scroll={{ x: 1300 }}/>
            <Modal
                title="Seleccionar items para la orden de trabajo"
                visible={isSelectItemsModalVisible}
                onCancel={closeSelectItemsModal}
                footer={[
                    <Button key="cancel" onClick={closeSelectItemsModal}>
                        Cancelar
                    </Button>,
                    <Button key="hire" type="primary" onClick={handleHireWithItems}>
                        Contratar
                    </Button>
                ]}
                width={900}
            >
                {selectedBidForHire && (
                    <div className="selectItemsModal">
                        {selectedBidForHire.items && Array.isArray(selectedBidForHire.items) && selectedBidForHire.items.length > 0 ? (
                            <Checkbox.Group
                                style={{ width: '100%' }}
                                value={[...selectedItemsKeys, ...usedItemsKeys]}
                                onChange={(values) => {
                                    // Filtrar para mantener solo los items seleccionados por el usuario (no los usados)
                                    const userSelected = values.filter(id => !usedItemsKeys.includes(id))
                                    setSelectedItemsKeys(userSelected)
                                }}
                            >
                                <Table
                                    dataSource={selectedBidForHire.items}
                                    rowKey="id"
                                    pagination={false}
                                    size="small"
                                    columns={[
                                        {
                                            title: '',
                                            key: 'checkbox',
                                            width: 50,
                                            render: (_, record) => {
                                                const isUsed = usedItemsKeys.includes(record.id)
                                                return (
                                                    <Checkbox 
                                                        value={record.id} 
                                                        disabled={isUsed}
                                                    />
                                                )
                                            }
                                        },
                                        {
                                            title: 'Nombre',
                                            dataIndex: 'name',
                                            key: 'name',
                                            width: 150,
                                            ellipsis: true,
                                        },
                                        {
                                            title: 'Descripción',
                                            dataIndex: 'description',
                                            key: 'description',
                                            ellipsis: {
                                                showTitle: false,
                                            },
                                            render: (text) => (
                                                <span title={text} style={{ wordBreak: 'break-word' }}>
                                                    {text}
                                                </span>
                                            ),
                                        },
                                        {
                                            title: 'Plazo (días)',
                                            dataIndex: 'days',
                                            key: 'days',
                                            width: 120,
                                            align: 'center',
                                            render: (days) => days ? `${days} días` : '-'
                                        },
                                        {
                                            title: 'Precio',
                                            dataIndex: 'price',
                                            key: 'price',
                                            width: 120,
                                            align: 'right',
                                            render: (price) => `$ ${price?.toFixed(2) || '0.00'}`
                                        }
                                    ]}
                                />
                            </Checkbox.Group>
                        ) : (
                            <Alert
                                message="Esta cotización no tiene items asociados"
                                description="Puede continuar con la contratación aunque no haya items seleccionados."
                                type="warning"
                                showIcon
                                style={{ marginBottom: 16 }}
                            />
                        )}
                        <div style={{ marginTop: '16px' }}>
                            <TextArea
                                placeholder="Observaciones"
                                rows={4}
                                value={quotationObservations}
                                onChange={(e) => setQuotationObservations(e.target.value)}
                                style={{ width: '100%' }}
                            />
                        </div>
                    </div>
                )}
            </Modal>
        </>
    )
}

BidOrdersTable.propTypes = {
    data: PropTypes.array,
    employees: PropTypes.object,
    clients: PropTypes.object,
    loading: PropTypes.bool,
    works: PropTypes.object
}

export default BidOrdersTable
